import type { EducationPackExamQuestionDetail } from "#/services/rest/gwt/exam-results/exam-results.types";
import { getModuleGroup } from "#/utils/legacyData/cache/generateHelper";
import { useEffect, useState } from "react";
import DesktopAdditionalReportFilter from "./Desktop";
import MobileAdditionalReportFilter from "./Mobile";

type Props = {
  data?: EducationPackExamQuestionDetail[];
};

const generateFilterModuleGroupItems = (
  details: EducationPackExamQuestionDetail[]
) => {
  const items: { label: string; value: string }[] = [];
  details.map((item) => {
    const moduleGroupItem = getModuleGroup(item.moduleGroupId);
    if (
      !items.filter(
        (moduleItem) => moduleItem.value === String(moduleGroupItem?.id)
      ).length
    )
      items.push({
        label: moduleGroupItem?.name ?? "",
        value: String(moduleGroupItem?.id)
      });
  });
  return items;
};

const AdditionalReportFilter = ({ data }: Props) => {
  const [moduleGroupFilters, setModuleGroupFilters] = useState<
    { label: string; value: string }[]
  >([]);

  useEffect(() => {
    if (data) setModuleGroupFilters(generateFilterModuleGroupItems(data));
  }, [data]);

  return (
    <>
      <DesktopAdditionalReportFilter moduleGroupFilters={moduleGroupFilters} />
      <MobileAdditionalReportFilter moduleGroupFilters={moduleGroupFilters} />
    </>
  );
};

export default AdditionalReportFilter;
